// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// API
import { getEMRJobs } from "../../api";

export const useEMRJobs = (
  clinicId: string | undefined,
  hubId: string | undefined
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<any>>({
    queryKey: ["emr-jobs", clinicId, hubId],
    queryFn: async () => {
      if (!clinicId || !hubId) throw new Error();
      const token = await getToken();
      return getEMRJobs(token, clinicId, hubId);
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the dashboard
  });
};
